// Danh sách email BGĐ (whitelist).
// So sánh theo lowercase + trim.
export const BGD_EMAILS = new Set([
  'luupd1@fsivietnam.com.vn',
  'trungvla@fsivietnam.com.vn',
  'caotvt@fsivietnam.com.vn',
  'trungtb@fsivietnam.com.vn',
  'hanhnth@fsivietnam.com.vn',
  'anhntn@fsivietnam.com.vn',
  'longnd@fsivietnam.com.vn',
  'hieutm@fsivietnam.com.vn',
  'dangbh@fsivietnam.com.vn',
  'hoangnt@fsivietnam.com.vn',
  'nguyenpk@fsivietnam.com.vn',
  'khanm@fsivietnam.com.vn',
  'quyenvt@fsivietnam.com.vn',
  'kietdh@fsivietnam.com.vn',
  'nganctt@fsivietnam.com.vn',
]);

export function isBGDEmail(email) {
  if (!email) return false;
  const normalized = String(email).trim().toLowerCase();
  return BGD_EMAILS.has(normalized);
}
